import { filter, flat, go, map } from "fxjs";
import React, { createContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";

export const ApplyContext = createContext();

const INITIAL_INQUIRYFINALLIST = [
	{
		category: "기본정보",
		description: "기업의 기본 정보를 입력해 주세요.",
		isRequired: true,
		disabled: true,
		option: [],
		order: 1,
		title: "기본정보",
		type: "CATEGORY",
	},
	{
		category: "",
		isRequired: true,
		disabled: true,
		option: [],
		order: 2,
		title: "기업명",
		type: "SHORT",
	},
	{
		category: "",
		isRequired: true,
		disabled: true,
		option: [],
		order: 3,
		title: "대표자 이름",
		type: "SHORT",
	},
	{
		category: "",
		isRequired: true,
		disabled: true,
		option: [],
		order: 4,
		title: "대표자 이메일",
		type: "SHORT",
	},
	{
		category: "",
		isRequired: true,
		disabled: true,
		option: [],
		order: 5,
		title: "설립연월",
		type: "DATE",
	},
	{
		category: "",
		isRequired: true,
		disabled: true,
		option: [],
		order: 6,
		title: "국가",
		type: "SELECT",
	},
	{
		category: "",
		isRequired: true,
		disabled: true,
		option: [],
		order: 7,
		title: "산업분야",
		type: "MULTISELECT",
	},
	{
		category: "투자정보",
		description: "기업의 투자 관련 정보를 입력해 주세요.",
		isRequired: true,
		disabled: true,
		option: [],
		order: 8,
		title: "투자정보",
		type: "CATEGORY",
	},
	{
		category: "",
		isRequired: true,
		disabled: true,
		option: [],
		order: 9,
		title: "투자단계",
		type: "SELECT",
	},
];

const ApplyRegContext = ({ children }) => {
	const [inquiryFinalList, setInquiryFinalList] = useState(INITIAL_INQUIRYFINALLIST);
	const [questionFinalList, setQuestionFinalList] = useState([]);
	const [orderNum, setOrderNum] = useState(1);
	const [qOrderNum, setQOrderNum] = useState(1);
	const [modInquiry, setModInquiry] = useState([]);
	const [modQuestion, setModQuestion] = useState([]);
	const [roundStatus, setRoundStatus] = useState();
	const [isUse, setIsUse] = useState();
	const listRequest = useRequest("get", "vc/apply/template");
	const [applyTopInfo, setApplyTopInfo] = useState();
	const formDetail = () => {
		listRequest.singleCall();
	};
	useEffect(() => {
		switch (listRequest.state) {
			case API_STATE.done:
				const requestApplyList = listRequest.response?.data;
				setInquiryFinalList(requestApplyList.template.inputs);
				setOrderNum(requestApplyList.template.inputs.length + 1);
				setIsUse(requestApplyList.template?.isUse);
				setQuestionFinalList(requestApplyList.template.qna || []);
				setQOrderNum(requestApplyList.template.qna?.length + 1);
				setApplyTopInfo(requestApplyList.template);
				break;
			default:
				break;
		}
	}, [listRequest.state, listRequest.response]);

	const inquiryAddCommon = (addData) => {
		setInquiryFinalList((prev) => [...prev, { ...addData, order: orderNum }]);
		setOrderNum(orderNum + 1);
	};

	const questionAddCommon = (addData) => {
		setQuestionFinalList((prev) => [...prev, { ...addData, order: qOrderNum }]);
		setQOrderNum(qOrderNum + 1);
	};

	const addCategory = () => {
		inquiryAddCommon({
			type: "CATEGORY",
			title: "",
			option: [],
			category: "",
			isRequired: false,
		});
	};

	const addInquiry = () => {
		inquiryAddCommon({
			type: "SHORT",
			title: "",
			content: "",
			option: [],
			isRequired: false,
			category: "",
		});
	};

	const addQuestion = () => {
		questionAddCommon({ question: "", answer: "" });
	};

	const setListByTarget = (target) => {
		setInquiryFinalList(
			inquiryFinalList.map((value) => (value.order === target.order ? target : value))
		);
	};

	useEffect(() => {
		if (applyTopInfo) {
			applyMangeForm.setValue("inquiry", applyTopInfo.title);
			applyMangeForm.setValue("inquiryDesc", applyTopInfo.description);
			applyMangeForm.setValue("sign", applyTopInfo?.image?.path);
			applyMangeForm.setValue("inquiryImg", applyTopInfo?.image?.path);
			applyMangeForm.setValue("reviewSettingIdx", applyTopInfo?.reviewSettingIdx);
			applyMangeForm.setValue("containInfoContents", applyTopInfo?.containInfoContents);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [applyTopInfo]);

	const handleQuestionInputChange = (index, event) => {
		const values = [...questionFinalList];
		if (event.target.id === "questionTitle" + index) {
			values[index].question = event.target.value;
		} else if (event.target.id === "questionValue" + index) {
			values[index].answer = event.target.value;
		}
		setQuestionFinalList(values);
	};

	const handleInquiryCopyFields = (orderNum) => {
		const temp = inquiryFinalList.find((d) => d.order === orderNum);
		let i = 1;
		let result = go(
			inquiryFinalList,
			map((a) => {
				if (a.order === orderNum) {
					return [a, temp];
				}
				return a;
			}),
			flat,
			map((a) => {
				return { ...a, order: i++ };
			})
		);
		setOrderNum(i);
		setInquiryFinalList(result);
	};

	const handleInquiryDelete = (orderNum) => {
		const temp = inquiryFinalList.filter((card) => card.order !== orderNum);
		let i = 1;
		temp.forEach((item) => (item.order = i++));
		setOrderNum(i);
		setInquiryFinalList(temp);
	};

	const handleQuestionCopyFields = (index) => {
		let temp = questionFinalList[index];
		let i = 1;
		let result = go(
			questionFinalList,
			map((a) => {
				if (a.order === index + 1) {
					return [a, temp];
				}
				return a;
			}),
			flat,
			map((a) => {
				return { ...a, order: i++ };
			})
		);
		setQOrderNum(i);
		setQuestionFinalList(result);
	};

	const handleQuestionRemoveFields22 = (event, index) => {
		event.preventDefault();
		// const values = [...questionFinalList];
		let i = 1;
		let result = go(
			questionFinalList,
			filter((a) => a.order !== index + 1),
			// flat,
			map((a) => {
				return { ...a, order: i++ };
			})
		);
		// values.splice(index, 1);
		setQuestionFinalList(result);
		setQOrderNum(qOrderNum - 1);
	};

	/**
	 * 드래그
	 * */

	const dragListChange = (list, dragOrderNum, endOrderNum) => {
		const temp = list.find((d) => d.order === dragOrderNum);

		let i = 1;
		let result = go(
			list,
			filter((a) => a.order !== parseInt(dragOrderNum)),
			map((a) => {
				if (parseInt(endOrderNum) === a.order) {
					if (dragOrderNum > endOrderNum) {
						return [temp, a];
					} else {
						return [a, temp];
					}
				}
				return a;
			}),
			flat,
			map((a) => {
				return { ...a, order: i++ };
			})
		);

		return result;
	};

	function changeRequired(e, orderNum) {
		setInquiryFinalList(
			inquiryFinalList.map((value) =>
				value.order === orderNum
					? { ...value, isRequired: e.target.value === "false" }
					: value
			)
		);
	}

	function dragListChangeInquiry(dragOrderNum, endOrderNum) {
		const result = dragListChange(inquiryFinalList, dragOrderNum, endOrderNum);
		setInquiryFinalList(result);
	}

	function dragListChangeQuestion(dragOrderNum, endOrderNum) {
		let result = dragListChange(questionFinalList, dragOrderNum, endOrderNum);
		setQuestionFinalList(result);
	}

	const cardForMainTitle = inquiryFinalList[0];

	const [searchParams, setSearchParams] = useSearchParams();

	const targetModifyIdx = searchParams.get("idx");

	// setInquiryFinalList

	useEffect(() => {
		if (modInquiry.length > 0) {
			setInquiryFinalList(modInquiry);
		}
	}, [modInquiry]);

	useEffect(() => {
		if (modQuestion.length > 0) {
			setQuestionFinalList(modQuestion);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modQuestion]);

	const applyMangeForm = useForm();

	// const inquiryForm = useForm({
	//     defaultValues: {
	// 		inquiryCategory: card.title,
	// 	},
	// });

	const [detailContent, setDetailContent] = useState("");
	const [externalLink, setExternalLink] = useState();
	const [check, setCheck] = useState(false);
	const mainImg = applyMangeForm.watch("sign");
	const reviewSettingIdx = applyMangeForm.watch("reviewSettingIdx");

	function defaultModalSubmit() {
		let temp = [...inquiryFinalList];
		let order = orderNum;
		let i = 0;
		if (inquiryDefaultInfo.companyName)
			temp = defaultAdd(temp, "SHORT", "기업명", "name", order + i++);
		if (inquiryDefaultInfo.establishment)
			temp = defaultAdd(temp, "DATE", "설립일자", "estDate", order + i++);
		if (inquiryDefaultInfo.address) temp = defaultAdd(temp, "ADDRESS", "주소", "address", order + i++);
		if (inquiryDefaultInfo.businessNumber)
			temp = defaultAdd(temp, "SHORT", "사업자등록번호", "regNum", order + i++);
		if (inquiryDefaultInfo.employee)
			temp = defaultAdd(temp, "SHORT", "직원수", "employeeNum", order + i++);
		if (inquiryDefaultInfo.homepage)
			temp = defaultAdd(temp, "SHORT", "홈페이지", "homepage", order + i++);
		if (inquiryDefaultInfo.ceo) temp = defaultAdd(temp, "SHORT", "대표", "ceoName", order + i++);
		if (inquiryDefaultInfo.companyType)
			temp = [
				...temp,
				{
					type: "CHOICE",
					title: "기업구분",
					content: "type",
					order: order + i++,
					required: false,
					selectOption: [{ title: "예비 창업" }, { title: "법인 사업자" }, { title: "개인 사업자" }],
				},
			];
		if (inquiryDefaultInfo.description)
			temp = defaultAdd(temp, "LONG", "기업개요", "introduction", order + i++);
		if (inquiryDefaultInfo.sales) temp = defaultAdd(temp, "SHORT", "매출", "", order + i++);
		if (inquiryDefaultInfo.nation) temp = defaultAdd(temp, "SHORT", "국가", "country", order + i++);
		if (inquiryDefaultInfo.productName)
			temp = defaultAdd(temp, "SHORT", "제품", "", order + i++);
		if (inquiryDefaultInfo.industry)
			temp = defaultAdd(temp, "SHORT", "산업분야", "fields", order + i++);
		if (inquiryDefaultInfo.stocks)
			temp = [
				...temp,
				{
					type: "ALTERNATIVE",
					title: "상장구분",
					content: "listed",
					order: order + i++,
					required: false,
					selectOption: [{ title: "상장" }, { title: "비상장" }],
				},
			];
		if (inquiryDefaultInfo.productDescription)
			temp = defaultAdd(temp, "LONG", "제품 한 줄 소개", "", order + i++);
		if (inquiryDefaultInfo.differentiation)
			temp = defaultAdd(temp, "LONG", "차별성", "", order + i++);
		if (inquiryDefaultInfo.keywords) temp = defaultAdd(temp, "TAG", "키워드", "", order + i++);

		setInquiryDefaultInfo({
			companyName: false, //기업명
			businessNumber: false, //사업자등록번호,
			ceo: false, // 대표
			sales: false, // 매출
			industry: false, // 산업분야
			differentiation: false, // 차별성
			establishment: false, // 설립일자
			employee: false, // 직원수
			companyType: false, // 기업구분
			nation: false, // 국가
			stocks: false, // 상장구분
			keywords: false, // 키워드
			address: false, // 주소
			homepage: false, // 홈페이지
			description: false, // 기업개요
			productName: false, // 제품명
			productDescription: false, // 제품한줄소개
		});
		setOrderNum(order + i);
		setInquiryFinalList(temp);
	}

	function defaultAdd(temp, type = "SHORT", title, content, orderNum) {
		return [
			...temp,
			{
				type: type,
				order: orderNum,
				selectOption: [],
				title: title,
				content: content,
				required: false,
			},
		];
	}

	const [inquiryDefaultInfo, setInquiryDefaultInfo] = useState({
		companyName: false, //기업명
		businessNumber: false, //사업자등록번호,
		ceo: false, // 대표
		sales: false, // 매출
		industry: false, // 산업분야
		differentiation: false, // 차별성
		establishment: false, // 설립일자
		employee: false, // 직원수
		companyType: false, // 기업구분
		nation: false, // 국가
		stocks: false, // 상장구분
		keywords: false, // 키워드
		address: false, // 주소
		homepage: false, // 홈페이지
		description: false, // 기업개요
		productName: false, // 제품명
		productDescription: false, // 제품한줄소개
	});

	return (
		<ApplyContext.Provider
			value={{
				addCategory,
				addInquiry,
				list: inquiryFinalList,
				setList: setInquiryFinalList,
				setListByTarget,
				dragListChange: dragListChangeInquiry,
				addQuestion,
				qList: questionFinalList,
				dragListChangeQuestion,
				handleQuestionInputChange,
				handleQuestionCopyFields,
				handleQuestionRemoveFields: handleQuestionRemoveFields22,
				handleInquiryCopyFields,
				handleInquiryDelete,
				applyMangeForm,
				detailContent,
				setDetailContent,
				mainImg,
				reviewSettingIdx,
				externalLink,
				setExternalLink,
				check,
				setCheck,
				inquiryDefaultInfo,
				setInquiryDefaultInfo,
				defaultModalSubmit,
				changeRequired,
				cardForMainTitle,
				modInquiry,
				setModInquiry,
				modQuestion,
				setModQuestion,
				roundStatus,
				setRoundStatus,
				targetModifyIdx,
				formDetail,
				isUse,
				setIsUse,
			}}
		>
			{children}
		</ApplyContext.Provider>
	);
};

export default ApplyRegContext;
